<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Facturación LibreDTE</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay documentos que coincidan con la búsqueda"
                    empty-text="No hay documentos registrados"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="success" size="sm" @click="getViewer(row.item.id)" :disabled="!row.item.pdf" v-b-modal.pdf>
                            <i class="material-icons">file_open</i>
                        </b-button>
                        <b-button variant="default" size="sm" @click="getDownload(row.item.id, row.item.pdf)" :disabled="!row.item.pdf">
                            <i class="material-icons">file_download</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal PDF Viewer -->
                <b-modal
                    id="pdf"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: '+id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <pdf :src="'/'+pdf" :alt="id" width="100%"></pdf>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";
import pdf from 'vue-pdf';

export default {
    name: "ReportInvoices",
    props: [ 'user' ],
    components: { pdf },
    data: () => ({
        id: 0,
        pdf: '',
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: true, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'folio', label: 'Folio', sortable: true, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'name', label: 'Usuario', sortable: true },
            { key: 'type', label: 'Tipo', sortable: true },
            { key: 'amount_text', label: 'Valor', sortable: true, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'date', label: 'Fecha', sortable: true },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'invoicespage');
        this.getData();
    },
    methods: {
        getData() {
            axios.get('/api/admin/reports/invoices').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        getViewer(id) {
            this.id = id;
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    this.pdf = items[i].pdf;
                }
            }
        },
        getDownload(id, url) {
            axios.get('/' + url, {
                responseType: 'blob'
            }).then((res) => {
                const blob = new Blob([res.data], {type: res.data.type});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const filename = res.headers['content-disposition'].split('filename=')[1];
                const name = 'Factura ' + id;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    }
}
</script>

<style scoped>

</style>
